import { render, staticRenderFns } from "./buttonExtractionOrders.vue?vue&type=template&id=1a9b0ffa&scoped=true&"
import script from "./buttonExtractionOrders.vue?vue&type=script&lang=js&"
export * from "./buttonExtractionOrders.vue?vue&type=script&lang=js&"
import style0 from "./buttonExtractionOrders.vue?vue&type=style&index=0&id=1a9b0ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b0ffa",
  null
  
)

export default component.exports